import { useCallback } from 'react';

import TableWrapper from './styles';
import { DynamicObjectType } from 'types/commons';
import { TableProps } from 'antd';

interface TableCustomProps extends Omit<TableProps, 'columns' | 'data'> {
  isResetStyle?: boolean;
  columns?: DynamicObjectType[];
  data?: DynamicObjectType[];
  xScroll?: number | string | boolean;
}

const TableCustom = ({
  columns,
  data,
  xScroll,
  pagination = {},
  isResetStyle,
  className,
  expandable,
  expandedRowKeys,
  ...props
}: TableCustomProps) => {
  const rowKey = (data = {} as DynamicObjectType, index) => data.id || index;

  const showTotal = useCallback(
    (total, range) => `${range[0]}-${range[1]}/${total}`,
    [],
  );

  return (
    <TableWrapper
      // isResetStyle={isResetStyle}
      columns={columns}
      dataSource={data}
      pagination={{
        showSizeChanger: true,
        showQuickJumper: true,
        showTotal,
        ...pagination,
      }}
      rowKey={rowKey}
      scroll={{ x: xScroll || 1100 }}
      expandable={expandable}
      expandedRowKeys={expandedRowKeys}
      {...props}
      className={`${className || ''} ${isResetStyle ? '' : 'table-wrapper'}`}
    />
  );
};

export default TableCustom;
